import { render, staticRenderFns } from "./AddTicketModal.vue?vue&type=template&id=10b28a0b&scoped=true&"
import script from "./AddTicketModal.vue?vue&type=script&lang=js&"
export * from "./AddTicketModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTicketModal.vue?vue&type=style&index=0&id=10b28a0b&prod&lang=css&"
import style1 from "./AddTicketModal.vue?vue&type=style&index=1&id=10b28a0b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b28a0b",
  null
  
)

export default component.exports